var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.8 14.8",
    style: {
      enableBackground: "new 0 0 14.8 14.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,8.4V6.6c0-0.6-0.5-1.1-1.1-1.1h-1.2c0.1-0.6-0.1-1.1-0.5-1.4C9.9,3.8,9.4,3.8,9,3.9 C8.5,4.1,8.1,4.4,7.8,4.8C7.7,5,7.6,5.2,7.5,5.5H6L9.2,1l4.3,3L12.8,5c-0.1,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0,0.3-0.1l0.7-1 C14,4,14,3.8,13.8,3.7L9.3,0.6C9.3,0.5,9.2,0.5,9.1,0.5C9,0.5,8.9,0.6,8.8,0.6l-1,1.5V1.2c0-0.2-0.2-0.3-0.3-0.3H2.1 C1.9,0.9,1.8,1,1.8,1.2v1.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2V1.3h0.6v4.1H2.3c0,0,0,0-0.1,0V3.4c0-0.1-0.1-0.2-0.2-0.2 c-0.1,0-0.2,0.1-0.2,0.2v2.2c-0.4,0.2-0.6,0.6-0.6,1v6.7c0,0.6,0.5,1.1,1.1,1.1h5.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2 H2.3c-0.4,0-0.7-0.3-0.7-0.7V6.6C1.6,6.3,1.8,6,2,5.9c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0H12c0.4,0,0.7,0.3,0.7,0.7v1.8H11 c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6h1.6v1.8c0,0.4-0.3,0.7-0.7,0.7H8.2C8.1,13.9,8,14,8,14.2c0,0.1,0.1,0.2,0.2,0.2H12 c0.6,0,1.1-0.5,1.1-1.1v-1.8c0.5-0.1,0.9-0.6,0.9-1.1V9.5C14,8.9,13.6,8.5,13.1,8.4z M8.2,5.1c0.5-0.7,1.3-1,1.8-0.7 c0.3,0.2,0.4,0.6,0.3,1H8C8,5.3,8.1,5.2,8.2,5.1z M7.4,2.8L5.5,5.5H4.4V1.3h3V2.8z M3.3,1.3h0.6v4.1H3.3V1.3z M13.5,10.4 c0,0.4-0.3,0.7-0.7,0.7H11c-0.6,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2h1.8c0.4,0,0.7,0.3,0.7,0.7V10.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e745a676443d481aca008275a09c792c.svg";
export { ForwardRef as ReactComponent };